(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // ─── Mega-nav hover dropdowns: optimized, consistent, smooth ───
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();
        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }
      reset() {
        const isLarge = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLarge;
        this.toggle[isLarge ? 'setAttribute' : 'removeAttribute']('tabindex', '-1');
      }
      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }
    customElements.define('nav-menu', NavMenu);
  });

  document.addEventListener('DOMContentLoaded', () => {
    // ─── Sync child-nav-scroll to the first-level panel ───
if (window.matchMedia(theme.mediaQueries.md).matches) {
  document.querySelectorAll('nav-menu > details').forEach(detail => {
    detail.addEventListener('toggle', () => {
      const panel    = detail.querySelector('.disclosure__panel');
      const scrollEl = panel?.querySelector('.child-nav-scroll');
      if (!scrollEl) return;

      if (detail.open) {
        // re-measure panel
        const { height } = panel.getBoundingClientRect();
        // absolutely position the scroll wrapper
        Object.assign(scrollEl.style, {
          position:   'absolute',
          top:        '0',
          left:       '0',
          width:      '100%',
          height:     `${height}px`,
          overflowY:  'auto',
          overflowX:  'hidden'
        });
      } else {
        // clean up on close
        scrollEl.style.cssText = '';
      }
    });
  });
}

    
    // Only on desktop
    if (!window.matchMedia(theme.mediaQueries.md).matches) return;

    // Track which detail → panel is open
    const openMap = new Map();

    // Restore panel into its original spot
    function restore(panel, detail) {
      const { parent, next } = panel.__orig;
      parent.insertBefore(panel, next);
      panel.classList.remove('flyout-panel', 'open');
      panel.style.cssText = '';
      openMap.delete(detail);
    }

    // Hide a submenu
    function hide(detail) {
      detail.open = false;
      const panel = openMap.get(detail);
      if (!panel) return;
      panel.classList.remove('open');
      panel.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName === 'transform') {
          panel.removeEventListener('transitionend', onEnd);
          restore(panel, detail);
        }
      });
    }

    // Show a submenu
function show(detail) {
  if (!window.matchMedia(theme.mediaQueries.md).matches) return;
  // ── NEW: measure header bottom every time ──
  const headerEl  = document.querySelector('store-header') || document.querySelector('.header');
  const topOffset = headerEl
    ? headerEl.getBoundingClientRect().bottom + window.scrollY
    : 0;

  // close siblings as before…
  openMap.forEach((_, other) => { if (other !== detail) hide(other); });

  detail.open = true;
  const panel = detail.querySelector('.disclosure__panel');
  if (!panel) return;

  // store original spot if needed
  if (!panel.__orig) {
    panel.__orig = { parent: panel.parentNode, next: panel.nextSibling };
  }
  openMap.set(detail, panel);

  panel.classList.add('flyout-panel');
  document.body.append(panel);

  const rect = detail.getBoundingClientRect();
  Object.assign(panel.style, {
    position: 'absolute',
    top:      `${topOffset}px`,                       // ← uses fresh value
    left:     `${rect.right + window.scrollX}px`,
    zIndex:   999
  });

  requestAnimationFrame(() => panel.classList.add('open'));
}



/* ─── Hover open/close for 2nd-level submenus (DESKTOP ONLY) ─── */
if (window.matchMedia(theme.mediaQueries.md).matches) {
  document
    .querySelectorAll('.main-nav__child details')
    .forEach(detail => {
      const panel = detail.querySelector('.disclosure__panel');
      if (!panel) return;

      // keep open while hovering
      detail.addEventListener('pointerenter', () => show(detail));
      panel.addEventListener('pointerenter',  () => show(detail));

      // close when leaving both toggle & panel
      function tryHide(e){
        const to = e.relatedTarget;
        if(!detail.contains(to) && !panel.contains(to)) hide(detail);
      }
      detail.addEventListener('pointerleave', tryHide);
      panel .addEventListener('pointerleave', tryHide);
    });
}

    


    // Global pointermove to catch “left both” edge cases
    document.addEventListener('pointermove', e => {
      openMap.forEach((panel, detail) => {
        if (!detail.contains(e.target) && !panel.contains(e.target)) {
          hide(detail);
        }
      });
    });

    // Root menu close → snap back all
    const root = document.querySelector('main-menu > details');
    root?.addEventListener('toggle', () => {
      if (!root.open) {
        openMap.forEach((_, detail) => hide(detail));
      }
    });

    // Click-outside → close all
    document.addEventListener('click', e => {
      if (!e.target.closest('main-menu')) {
        openMap.forEach((_, detail) => hide(detail));
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
